export interface IUserAccount {
  userName: string;
  name: string;
  hashedPassword?: number;
  rut: string | null;
  rol?: number;
  active: boolean;
  email: string;
  role: UserRole;
  roleName: string;
  lastLogin: string;
  expirationTime?: Date;
  //costCentres: number[] | null;
  //driverRuts: string[] | null;
}

export enum UserAccountType {
  Sgi,
  Inspector,
  Driver,
}

export enum UserRole {
  Driver,
  SuperUser,
  AdmRRHH,
  Inspector,
}

export enum InspectorStatus {
  SUCCESSFULLY_ACTIVATED = 0,
  ALREADY_ACTIVATED,
  ERROR,
}
export interface UserInspectorResource {
  email?: string;
  expirationDate: Date | null;
  status: InspectorStatus | null;
}

export interface HistoryUserInspectorResource {
  connectionDate: string;
  email?: string;
  rutCompany: string;
  companyName: string;
  ipAddress: string;
}
